import request from "@/utils/request";

export function hanldeGet(url, params, config = {}) {
  return request({
    url: url,
    method: "get",
    params,
    ...config,
  });
}

export function hanldePost(url, data, config = {}) {
  return request({
    url: url,
    method: "post",
    data,
    ...config,
  });
}

export function hanldeForm(url, data, config = {}) {
  return request({
    url: url,
    method: "post",
    type: "1",
    data,
    ...config,
  });
}

export function hanldedownGet(url,params, config = {}) {
  return request({
    url,
    method: "get",
    params,
    ...config,
    responseType: "blob",
  });
}
export function hanldedown(params, config = {}) {
  return request({
    url: "/api/business/file/download",
    method: "get",
    params,
    ...config,
    responseType: "blob",
  });
}


export function hanldedowns(params, config = {}) {
  return request({
    url: "/api/business/generation/dueDiligenceReport",
    method: "get",
    params,
    ...config,
    responseType: "blob",
  });
}

export default { hanldeGet,hanldedownGet, hanldePost,hanldedown,hanldedowns, hanldeForm };
